import { Column } from '@synqo/frontend-component-library';
import { ApiMandant } from '@Model';

export const mandantColumns: Column<ApiMandant>[] = [
    { name: 'name', label: 'Name' },
    { name: 'number', label: 'Nummer' },
    { name: 'client.display_string', label: 'Kunde' },
];
